import {Routes, Route} from 'external/react' 
import {getLanguageRoute} from 'utils/routing'

import withStoreProvider from 'components/Uploads/redux/withStoreProvider'
import withFullContext from 'context'
import Container from 'components/Container'
import Dashboard from 'components/Dashboard'
import MyCourses from 'components/MyCourses'
import Gradebook from 'components/Gradebook'
import Schedule from 'components/Schedule'
import Help from 'components/Help'
import CarruselVideos from 'components/CarruselVideos'

import {ThemeProvider} from 'external/material'
import EduSystemTheme from 'themes/edusystem'

const pages = [
  {names: ['dashboard', ''], element: (<Dashboard />)},
  {names: ['videos'], element: (<CarruselVideos/>)},
  {names: ['my-courses', 'mis-cursos'], element: (<MyCourses />)},
  {names: ['chat'], element: <div style={{display: 'none'}} />},
  {names: ['gradebook', 'calificaciones'], element: (<Gradebook />)},
  {names: ['downloads', 'descargas'], element: (<Dashboard />)},
  {names: ['schedule', 'calendario'], element: (<Schedule />)},
  {names: ['help', 'ayuda'], element: (<Help />)}
]
const routes = pages.reduce((routes, {names, element}) => routes.concat(names.map(name => ({path: `${getLanguageRoute(name)}/*`, element}))), []) 

function App() {
  return (
    <Routes>
      <Route path="/" element={<ThemeProvider theme={EduSystemTheme}><Container /></ThemeProvider>}>
        {routes.map(({path, element}, key) => (<Route path={path} element={element} key={key} />))}
      </Route>
    </Routes>
  )
}

const AppWithContext = withFullContext(App)
AppWithContext.displayName = 'AppWithContext'

const AppWithStoreProvider = withStoreProvider(AppWithContext)
AppWithStoreProvider.displayName = 'AppWithStoreProvider'

export {AppWithStoreProvider as default}
